// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // Apenas getAuth é necessário aqui

// SUBSTITUA PELOS SEUS DADOS COPIADOS DO FIREBASE
export const firebaseConfig = {
  apiKey: "AIzaSyCfzzTrrTPxBf1sYcwoVcDPLTgipMXTQqk",
  authDomain: "controle-de-sistemas-fbf6a.firebaseapp.com",
  projectId: "controle-de-sistemas-fbf6a",
  storageBucket: "controle-de-sistemas-fbf6a.firebasestorage.app",
  messagingSenderId: "644701227004",
  appId: "1:644701227004:web:b2da73b4a4a50fec799479"
};
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);